import { useEffect } from "react";

/**
 * Ctrl/⌘ + S — and Ctrl/⌘ + Enter — saves the screen you are on, so you never have to scroll
 * back up to a SAVE button. The browser's own save dialog is suppressed only while the screen
 * is open; no other shortcut is touched.
 */
export const useSaveShortcut = (onSave, enabled = true) => {
    useEffect(() => {
        if (!enabled || !onSave) return undefined;
        const onKey = (e) => {
            const key = e.key?.toLowerCase();
            if (!(e.ctrlKey || e.metaKey) || e.altKey || e.shiftKey) return;
            if (key !== "s" && key !== "enter") return;
            e.preventDefault();
            onSave();
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [onSave, enabled]);
};

export const saveKeyLabel = () =>
    (typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform || "") ? "⌘" : "CTRL");

export default useSaveShortcut;
